import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

console.log("React Version", React.version);
const rootEl = document.getElementById("root");

if (rootEl) {
    const root = createRoot(rootEl);
    root.render(<App />);
}
